<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
@if (!isLoading) {
  <div class="col-12 pb-5">
    <ziro-did-selector-form
      [dialPlanGroups]="dialPlanFieldConfig"
      [entity]="didSelectorFormData"
      [webexFieldConfigV1]="webexFieldConfigV1"
      [webexFieldConfigV2]="webexFieldConfigV2"
      [enableWebexPerSite]="enableWebexPerSite"
      [extensionDetailsEntity]="extensionDetailsEntity"
      [parentSubmit$]="parentSubmit$"
      (ziroFormsUpdate$)="onFormUpdate($event, 'DID_SELECTOR_FORM')"
    ></ziro-did-selector-form>
    <ziro-extension-details-form
      [webexFieldConfigV1]="webexFieldConfigV1"
      [entity]="extensionDetailsEntity"
      [didSelectorFormData]="didSelectorFormData"
      [parentSubmit$]="parentSubmit$"
      (ziroFormsUpdate$)="onFormUpdate($event, 'EXTENSION_DETAILS_FORM')"
    ></ziro-extension-details-form>
  </div>
}
